import { create } from 'zustand';
import { AlertSrv } from '../helpers';
import { ConfirmAction } from '../confirm-action/ConfirmAction';

export const ListBaseController = (options: any) => {
    const { defaultFilterModel = {}, actions, pageConfig, customActions, cascadingMap = {} } = options;

    const getItems = (set: any, get: any) => {
        return async () => {
            let inputData: any = {
                data: {
                    filters: get().filterModel,
                    startIndex: get().startIndex,
                    pageSize: get().pageSize,
                    sorters: get().sorters
                },
            };
            let response = await actions.getItems(inputData);
            set({ items: response.items, totalRecords: response.pagerResult?.totalCount });
        }
    }

    const getLookups = (set: any, get: any) => {
        return async () => {
            let lookupKeyList = get().lookupKeys;
            if (lookupKeyList && actions.getLookups) {
                const inputData: any = {
                    "lookups": lookupKeyList
                };
                let result = await actions.getLookups(inputData);
                set({ lookup: result });
            }
        }
    }

    const deleteItem = (set: any, get: any) => {
        return async (item: any = {}) => {
            await actions.deleteItem({ _id: item._id });
            AlertSrv.showSuccessMsg('Deleted successfully!');
            await get().getItems({});
        }
    }

    const confirmDelete = (set: any, get: any) => {
        return async (item: any, placeholderKey: any) => {
            let message = "Do you want to delete?"
            if (placeholderKey) {
                message = `Do you want to delete ${item[placeholderKey]}?`;
            }
            ConfirmAction({
                message: message,
                okAction: deleteItem(set, get),
                item: item
            });
        }
    }

    const handleFilterInputChange = (set: any, get: any) => {
        return async (item: any) => {
            let data: any = { [item.name]: item.value };
            let currentModel = get().filterModel;
            let sorters = get().sorters;
            let inputData = { ...currentModel, ...data };
            set({ filterModel: inputData, startIndex: 0, pageNo: 1, sorters: sorters });

            //load the items based on filters
            await get().getItems({});
        }
    }


    const setFormOptions = (set: any, get: any) => {
        return (data: any) => {
            let filterModel = data.formModel || {};
            let lookupKeys = data.lookupKeys || {};
            let cascadingMap = data.cascadingMap || {};

            set({ filterModel: filterModel, lookupKeys: lookupKeys, cascadingMap });
        }
    }

    const processCascadingLookups = (set: any, get: any) => {
        return async (changedModelProp: any) => {
            let cascadingMap = get().cascadingMap;
            if (cascadingMap[changedModelProp]) {
                var lookupConfig: any = {};
                var filters: any = {};
                let filterModel = get().filterModel;
                let currentLookup = get().lookup;

                var result = cascadingMap[changedModelProp];
                for (let modelProp in result) {
                    var modelObj = result[modelProp];
                    lookupConfig[modelObj.lookupKey] = { default: true };
                    filters[changedModelProp] = filterModel[changedModelProp];
                }
                let latestLookup = await getSpecificLookups(lookupConfig, filters, currentLookup);
                set({ lookup: latestLookup });
            }
        }
    }

    const getSpecificLookups  = async (lookupConfig: any, filters: any, currentLookup: any) => {
            //if (!this.utl.isEmptyJSONObject(lookupConfig)) {
            var inputData = {
                lookups: lookupConfig,
                filters: filters
            };
            let result = await actions.getLookups(inputData);
            currentLookup = JSON.parse(JSON.stringify(currentLookup));
            for (let key in result) {
                currentLookup[key] = result[key];
            }
            return currentLookup;
            //}
    }

    const pageChanged = (set: any, get: any) => {
        return async ({ pageNo, startIndex }: any) => {
            set({ startIndex: startIndex || 0 });
            await get().getItems({});
        }
    }

    const setPagerOptions = (set: any, get: any) => {
        return (pagerConfig: any) => {
            let startIndex = pagerConfig.startIndex || 0;
            let pageSize = pagerConfig.pageSize || 0;
            set({ startIndex: startIndex, pageSize: pageSize });
        }
    }

    const sorterChanged = (set: any, get: any) => {
        return async (sorters: any) => {
            set({ sorters: sorters });
            await get().getItems({});
        }
    }

    const setSorterOptions = (set: any, get: any) => {
        return (sortConfig: any) => {
            let sorters: any = [];
            if (sortConfig && sortConfig.sortable && sortConfig.sortInfo) {
                sorters.push(sortConfig.sortInfo);
            }
            set({ sorters: sorters });
        }
    }

    const prepareCustomActions = (set: any, get: any) => {
        let result: any = {};
        for (let key in customActions) {
            result[key] = customActions[key](set, get)
        }
        return result;
    }

    const getStore = () => {
        return create<any>((set: any, get: any) => ({
            pageConfig: pageConfig,
            filterModel: defaultFilterModel,
            lookup: {},
            cascadingMap: cascadingMap,
            items: [],
            startIndex: 0,
            pageNo: 1,
            pageSize: 0,
            totalRecords: 0,
            pageChanged: pageChanged(set, get),
            sorterChanged: sorterChanged(set, get),
            getItems: getItems(set, get),
            getLookups: getLookups(set, get),
            deleteItem: deleteItem(set, get),
            confirmDelete: confirmDelete(set, get),
            handleFilterInputChange: handleFilterInputChange(set, get),
            setFormOptions: setFormOptions(set, get),
            setPagerOptions: setPagerOptions(set, get),
            setSorterOptions: setSorterOptions(set, get),
            processCascadingLookups: processCascadingLookups(set, get),
            ...prepareCustomActions(set, get)
        }));
    }


    return { getItems, getLookups, deleteItem, confirmDelete, getStore, handleFilterInputChange };
}